import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import EmptyMessage from 'components/empty-message';
import OrderCard from './order-card';
import styles from './styles.css';

export default class OrderGrid extends Component {
    static propTypes = {
        orders: PropTypes.array,
        columns: PropTypes.number.isRequired,
    };

    render() {
        if (this.props.orders.length === 0) {
            return <EmptyMessage message='Todavía no se registran pedidos.' />;
        }

        return (
            <div className={classNames(styles.root, styles[`columns${this.props.columns}`])}>
                {this.props.orders.map(order => (
                    <OrderCard key={order.id} order={order} />
                ))}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/order-grid/index.js